import React from "react"

const NotFound: React.FC = () => {
  return <h2>NotFound</h2>
}

export default NotFound
